import React from 'react';
import { businessInfo } from '../config/info';
import { seo } from '../config/seo';

/**
 * Structured data for LodgingBusiness + WebSite (Google rich results / local pack signals).
 */
const SeoJsonLd = () => {
  const base = seo.siteUrl;
  const sameAs = Object.values(businessInfo.socialLinks || {}).filter(
    (u) => typeof u === 'string' && u.trim().startsWith('http')
  );

  const mobileE164 = businessInfo.phones
    .map((p) => {
      const d = p.replace(/\D/g, '');
      return d.length === 10 ? `+91${d}` : null;
    })
    .filter(Boolean);

  const graph = [
    {
      '@type': 'LodgingBusiness',
      '@id': `${base}/#lodging`,
      name: businessInfo.name,
      description: seo.metaDescription,
      url: base,
      image: `${base}/android-chrome-512x512.png`,
      ...(mobileE164.length ? { telephone: mobileE164.join(', ') } : {}),
      email: businessInfo.email || undefined,
      address: {
        '@type': 'PostalAddress',
        streetAddress: '17/665-B EB Road, Sholayar Dam (P.O)',
        addressLocality: 'Sholayar Dam, Valparai',
        addressRegion: 'Tamil Nadu',
        postalCode: '642125',
        addressCountry: 'IN',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: seo.latitude,
        longitude: seo.longitude,
      },
      priceRange: '$$',
      ...(sameAs.length ? { sameAs } : {}),
    },
    {
      '@type': 'WebSite',
      '@id': `${base}/#website`,
      url: base,
      name: businessInfo.name,
      description: seo.metaDescription,
      inLanguage: 'en-IN',
      publisher: { '@id': `${base}/#lodging` },
      potentialAction: {
        '@type': 'ReserveAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${base}/book`,
        },
      },
    },
    {
      '@type': 'FAQPage',
      '@id': `${base}/#faq`,
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Where is the best resort or hotel stay in Sholayar Dam near Valparai?',
          acceptedAnswer: {
            '@type': 'Answer',
            text:
              "Chan's Nest Inn on EB Road, Sholayar Dam (P.O), Valparai 642125, offers resort-style rooms and guest-house comfort between Sholayar reservoir and Valparai hill station — ideal for families and couples visiting tea estates and the Western Ghats.",
          },
        },
        {
          '@type': 'Question',
          name: 'How do I book rooms in Valparai or Sholayar Dam?',
          acceptedAnswer: {
            '@type': 'Answer',
            text:
              "Use the Book Your Stay page on chansnest.in to check availability and reserve rooms online, or call the phone numbers listed in the footer for WhatsApp and direct booking.",
          },
        },
        {
          '@type': 'Question',
          name: 'Is Chan\'s Nest Inn good for a Valparai hill station trip?',
          acceptedAnswer: {
            '@type': 'Answer',
            text:
              'Yes — guests choose Chan\'s Nest Inn for quiet stays, Sholayar Dam location, and access to Valparai sightseeing, hairpin routes, and nearby nature spots in Tamil Nadu.',
          },
        },
      ],
    },
  ];

  const payload = { '@context': 'https://schema.org', '@graph': graph };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(payload) }}
    />
  );
};

export default SeoJsonLd;
